module.exports = __webpack_public_path__ + "img/compact.0b7b1a84.png";